export const NOTIFICATION_CLIENT_ACTIONS = 'NOTIFICATION_CLIENT_ACTIONS';
export const NOTIFICATION_VIEW_CLIENT = 'NOTIFICATION_VIEW_CLIENT';
export const NOTIFICATION_CREATE_ADMIN_USER = 'NOTIFICATION_CREATE_ADMIN_USER';
export const NOTIFICATION_VIEW_DOCUMENT = 'NOTIFICATION_VIEW_DOCUMENT';
export const NOTIFICATION_ORDER_ACTIONS = 'NOTIFICATION_ORDER_ACTIONS';
export const NOTIFICATION_ADMIN_ACTIONS = 'NOTIFICATION_ADMIN_ACTIONS';
export const NOTIFICATION_VIEW_ADMIN = 'NOTIFICATION_VIEW_ADMIN';
export const NOTIFICATION_VIEW_ADMIN_GROUP = 'NOTIFICATION_VIEW_ADMIN_GROUP';
export const NOTIFICATION_ADMIN_GROUP_ACTIONS = 'NOTIFICATION_ADMIN_GROUP_ACTIONS';
export const NOTIFICATION_CREATE_ADMIN_GROUP = 'NOTIFICATION_CREATE_ADMIN_GROUP';
export const NOTIFICATION_ADD_ADMIN_GROUP = 'NOTIFICATION_ADD_ADMIN_GROUP';
export const NOTIFICATION_CREATE_ORDER = 'NOTIFICATION_CREATE_ORDER';
export const NOTIFICATION_EDIT_USER_DETAILS = 'NOTIFICATION_EDIT_USER_DETAILS';
export const NOTIFICATION_CHANGE_PASSWORD = 'NOTIFICATION_CHANGE_PASSWORD';
export const NOTIFICATION_REFUND_MODAL = 'NOTIFICATION_REFUND_MODAL';
export const NOTIFICATION_TICKETS_ACTIONS = 'NOTIFICATION_TICKETS_ACTIONS';
export const NOTIFICATION_VIEW_TICKET = 'NOTIFICATION_VIEW_TICKET';
export const NOTIFICATION_TICKET_MODAL = 'NOTIFICATION_TICKET_MODAL';
export const NOTIFICATION_SEND_EMAIL_USER = 'NOTIFICATION_SEND_EMAIL_USER';
export const NOTIFICATION_CREATE_CAMPAIGN = 'NOTIFICATION_CREATE_CAMPAIGN';
export const NOTIFICATION_UPDATE_CAMPAIGN = 'NOTIFICATION_UPDATE_CAMPAIGN';
export const NOTIFICATION_CAMPAIGN_ACTIONS = 'NOTIFICATION_CAMPAIGN_ACTIONS';
export const NOTIFICATION_COUPON_ACTIONS = 'NOTIFICATION_COUPON_ACTIONS';
export const NOTIFICATION_CREATE_COUPON = 'NOTIFICATION_CREATE_COUPON';
export const NOTIFICATION_CERTIFICATE_APPOINTMENT = 'NOTIFICATION_CERTIFICATE_APPOINTMENT';
export const NOTIFICATION_ADD_APPOINTMENT_HOLIDAY = 'NOTIFICATION_ADD_APPOINTMENT_HOLIDAY';

export const NOTIFICATION_LIST_CERTIFICATES = 'NOTIFICATION_LIST_CERTIFICATES';
export const NOTIFICATION_CERTIFICATE_ACTIONS = 'NOTIFICATION_CERTIFICATE_ACTIONS';
export const NOTIFICATION_ARCHIVE_SERVICE_ACTIONS = 'NOTIFICATION_ARCHIVE_SERVICE_ACTIONS';
export const NOTIFICATION_VIEW_ORGANIZATION = 'NOTIFICATION_VIEW_ORGANIZATION';
export const NOTIFICATIONS_CHANGE_ACCOUNT_SECURITY = 'NOTIFICATIONS_CHANGE_ACCOUNT_SECURITY';
export const NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS = 'NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS';
export const NOTIFICATION_CREATE_EMAIL_CAMPAIGN = 'NOTIFICATION_CREATE_EMAIL_CAMPAIGN';
export const NOTIFICATION_VIEW_EMAIL_CAMPAIGN = 'NOTIFICATION_VIEW_EMAIL_CAMPAIGN';
export const NOTIFICATION_CHANGE_PACKAGE_OWNER_MODAL = 'NOTIFICATION_CHANGE_PACKAGE_OWNER_MODAL';
export const NOTIFICATION_CHANGE_PACKAGE_GROUP_MODAL = 'NOTIFICATION_CHANGE_PACKAGE_GROUP_MODAL';
